var utils = require('../../utils')

export default {
  name: 'message-list',
  created () {
    var method, id, param, data
    if (window.sessionStorage.getItem('message_list_search_conditions')) {
      data = JSON.parse(window.sessionStorage.getItem('message_list_search_conditions'))
      method = data['method']
      id = data['id']
      param = data['param']
      this.keyword = data['keyword']
    }
    this.search(method, id, param)
  },
  data () {
    return {
      searchCallbackFlag: false,
      keyword: null,
      keywordSearchCallbackFlag: true,
      selectShopName: '',
      searchShow: '',
      padding: '',
      background: ''
    }
  },
  computed: {
    messages() {
      return this.$store.getters.messages
    },
    isShopMaster () {
      return window.localStorage.getItem('is_shop_master') === '1'
    },
    isOfficer() {
      return window.localStorage.getItem('is_officer') === '1'
    },
    isHarassment() {
      return window.localStorage.getItem('is_harassment') === '1'
    },
    messageKeywordShops () {
      return this.$store.getters.messageKeywordShops
    },
    messageKeywordUsers () {
      return this.$store.getters.messageKeywordUsers
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    }
  },
  methods: {
    goTop: function () {
      window.sessionStorage.removeItem('message_list_search_conditions')
      this.$router.push({ path: '/'})
    },
    goMessageDetail: function (messageId) {
      this.$router.push({ path: '/message/' + messageId})
    },
    search: function (method, id, param) {
      this.clearFlags()
      var self = this
      var data = {}
      if (method == 'shop') {
        this.selectShopName = !!param? param : ''
        data['shop_id'] = id
      } else if (method == 'user') {
        data['user_id'] = id
      } else if (method == 'keyword') {
        data['keyword'] = self.keyword
      }
      var callback = function () {
        self.searchCallbackFlag = true
        self.checkUnread()
        self.focusOut()
      }
      var savedata = {
        'method': method,
        'id': id,
        'param': param,
        'keyword': (self.keyword)? self.keyword:''
      }
      window.sessionStorage.setItem('message_list_search_conditions', JSON.stringify(savedata))
      if (this.isShopMaster) {
        data['recieve_user_id'] = window.localStorage.getItem('user_id')
        data['shop_id'] = window.localStorage.getItem('shop_id')
        data['is_shop_master'] = window.localStorage.getItem('is_shop_master')
        this.$store.dispatch('GET_MESSAGEMANAGER_LIST', { data: data, callback: callback })
      }
      if (this.isOfficer) {
        data['recieve_user_id'] = window.localStorage.getItem('user_id')
        this.$store.dispatch('GET_MESSAGEOFFICER_LIST', { data: data, callback: callback })
      }
      if (this.isHarassment) {
        data['recieve_user_id'] = window.localStorage.getItem('user_id')
        this.$store.dispatch('GET_MESSAGEHARASSMENT_LIST', { data: data, callback: callback })
      }
    },
    keywordSearch: function() {
      this.clearFlags()
      if (this.keyword) {
        var url = null
        var self = this
        var callback = function () {
          self.keywordSearchCallbackFlag = true
          // 退職者一覧店舗を表示しない
          var workIndex = -1
          for (var i = 0; i < self.messageKeywordShops.length; i++) {
            if (self.messageKeywordShops[i].id == 800) {
              workIndex = i
              break;
            }
          }
          if (workIndex != -1) {
            self.messageKeywordShops.splice(workIndex, 1)
          }
          // 瀬高店を表示しない
          let shopIdSetaka = -1
          for (let i = 0; i < self.messageKeywordShops.length; i++) {
            if (self.messageKeywordShops[i].id === '4') {
              shopIdSetaka = i
              break
            }
          }
          if (shopIdSetaka !== -1) {
            self.messageKeywordShops.splice(shopIdSetaka, 1)
          }
          // 情報システム部を表示しない
          let shopSystem = -1
          for (let i = 0; i < self.messageKeywordShops.length; i++) {
            if (self.messageKeywordShops[i].id === '730') {
              shopSystem = i
              break
            }
          }
          if (shopSystem !== -1) {
            self.messageKeywordShops.splice(shopSystem, 1)
          }
          // 採用部を表示しない
          let shopSaiyo = -1
          for (let i = 0; i < self.messageKeywordShops.length; i++) {
            if (self.messageKeywordShops[i].id === '750') {
              shopSaiyo = i
              break
            }
          }
          if (shopSaiyo !== -1) {
            self.messageKeywordShops.splice(shopSaiyo, 1)
          }
          if (self.keyword) {
            self.focusGet()
          }
        }
        var data = {
          'keyword': this.keyword,
          'shop_id': window.localStorage.getItem('shop_id'),
          'is_shop_master': window.localStorage.getItem('is_shop_master')
        }
        this.$store.dispatch('MESSAGE_KEYWORD_SEARCH', {url: url, data: data, callback: callback})
      } else {
        this.search()
      }
    },
    clearFlags: function() {
      this.keywordSearchCallbackFlag = false
      this.searchCallbackFlag = false
      this.selectShopName = ''
    },
    getMessageContent: function(messageContent) {
      var stringMaxLength = 73
      if (messageContent.length > stringMaxLength) {
        messageContent = messageContent.substring(0, stringMaxLength)
      }
      return messageContent ? this.content(messageContent) + '<br><span>…もっと見る</span>': ''
    },
    unread: function (alreadyRead) {
      if (alreadyRead == 0) {
        return '-unread'
      } else {
        return ''
      }
    },
    focusGet: function () {
      this.searchShow = '-show'
      this.padding = 'padding-bottom: 300px;'
    },
    focusOut: function () {
      this.searchShow = ''
      this.padding = 'padding-bottom: 1px;'
    },
    checkUnread: function () {
      if (this.messages && this.messages.length > 0 && this.messages[0].attributes['is-already-read'] == 0) {
        this.background = '-unread'
      }
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    },
    rmEmoji: function(text) {
      this.keyword = utils.removeEmoji(text)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/message-list.js